import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimerService {
    Timer;
    seconds = new BehaviorSubject(0);
    minutes = new BehaviorSubject(0);
    total = new BehaviorSubject(0);

    scoreTimer;
    scoreSeconds = new BehaviorSubject(1);

    startTimer() {
        this.Timer = setInterval(() => {
            const currentSeconds = this.seconds.getValue();
            const currentMinutes = this.minutes.getValue();
            const currentTotal = this.total.getValue();
            this.total.next(currentTotal + 1);

            if (currentSeconds == 59) {
                this.seconds.next(0);
                this.minutes.next(currentMinutes + 1);
            } else {
                this.seconds.next(currentSeconds + 1);
            }
        }, 1000);

        this.scoreTimer = setInterval(() => {
            this.scoreTimerInterval();
        }, 100);
    }

    scoreTimerInterval() {
        const currentScoreSeconds = this.scoreSeconds.getValue();
        // console.log(currentScoreSeconds);
        this.scoreSeconds.next(currentScoreSeconds + 1);
    }

    getTime() {
        let minutes: string;
        let seconds: string;
        const total = this.total.getValue();
        // const total = 67;

        minutes = Math.floor(total / 60) < 10 ? "0" + Math.floor(total / 60).toString() : Math.floor(total / 60).toString();
        seconds = total % 60 < 10 ? "0" + (total % 60).toString() : (total % 60).toString();
        return {
            time: (minutes + ":" + seconds),
            total: total
        };
    }

    pauseTimer() {
        clearInterval(this.Timer);
        // this.resetScoreTimer();
    }

    resetTimer() {
        clearInterval(this.Timer);
        this.seconds.next(0);
        this.minutes.next(0);
        this.resetScoreTimer()
    }

    resetScoreTimer() {
        clearInterval(this.scoreTimer);
        this.scoreSeconds.next(1);
    }

    restartScoreTimer() {
        // this.resetScoreTimer();
        clearInterval(this.scoreTimer);
        this.scoreSeconds.next(1);
        this.scoreTimer = setInterval(() => {
            this.scoreTimerInterval();
        }, 100);
    }

    startQuestionTimer() {
        this.seconds.next(59);
        this.Timer = setInterval(() => {
            const currentSeconds = this.seconds.getValue();
            if (currentSeconds == 0) {
                this.seconds.next(0);
                clearInterval(this.Timer);
            } else {
                this.seconds.next(currentSeconds - 1);
            }
        }, 1000);
    }

    stopQuestionTimer() {
        clearInterval(this.Timer);
    }
}